<template>
  <div>
    <slot name="label" v-if="$slots.label" />

    <div class="q-mb-sm" v-if="label && !$slots.label">
      <div>
        {{ label }}
        <span class="text-negative" v-if="required">*</span>
      </div>
    </div>

    <!-- Description -->
    <slot name="description" v-if="$slots.description" />
    <div class="text-secondary text-caption q-mb-xs" v-if="description">{{ description }}</div>

    <q-btn-toggle
      v-model="inputValue"
      toggle-color="primary"
      :options="options"
      :disable="disable"
      :spread="spread"
      :size="size"
      no-caps
      unelevated
      class="toggle-style"
      color="white"
      text-color="primary"
    />
  </div>
</template>

<script>
/**
 * Button Toggle.
 * Using quasar ButtonToggle.
 * https://quasar.dev/vue-components/button-toggle
 *
 * [Props]
 * options: [{label: string, value: string}]
 */

export default {
  name: 'ButtonToggle',
  props: {
    value: {
      type: [String, Number],
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
    },
    disable: {
      type: Boolean,
    },
    spread: {
      type: Boolean,
    },
    unelevated: {
      type: Boolean,
    },
    outline: {
      type: Boolean,
    },
    size: {
      type: String,
      default: 'md',
      validator: (size) =>
        ['xs', 'sm', 'md', 'lg', 'xl', 'small', 'medium', 'large'].includes(size),
    },
  },

  computed: {
    inputValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss">
@import '~quasar/src/css/variables';

.toggle-style {
  > button {
    border: 1px solid $primary;

    &:not(:last-child) {
      border-right: 0;
    }
  }
}
</style>
